import { render, staticRenderFns } from "./MyAbstracts.vue?vue&type=template&id=b9e73ec8&scoped=true"
import script from "./MyAbstracts.vue?vue&type=script&lang=js"
export * from "./MyAbstracts.vue?vue&type=script&lang=js"
import style0 from "./MyAbstracts.vue?vue&type=style&index=0&id=b9e73ec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e73ec8",
  null
  
)

export default component.exports